var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSideButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "PF_side_button",
    "data-name": "PF side button",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 172,
    height: 37,
    viewBox: "0 0 172 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_89",
    x: 117.5,
    y: 4.5,
    width: 49,
    height: 30,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.084,
    x2: -0.279,
    y2: 1.605,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8d8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be2121"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(-206 -231)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141",
    "data-name": "Rectangle 141",
    width: 172,
    height: 37,
    rx: 18.5,
    transform: "translate(206 231)",
    fill: "#21c3a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-stars",
    "data-name": "Icon material-stars",
    d: "M16.778,3A13.792,13.792,0,1,0,30.583,16.792,13.785,13.785,0,0,0,16.778,3Zm5.848,22.067L16.792,21.55l-5.834,3.517L12.5,18.433,7.358,13.978l6.785-.579,2.648-6.261,2.648,6.248,6.785.579-5.144,4.455,1.545,6.648Z",
    transform: "translate(207.565 232.721)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(-206 -231)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 206, 231)",
    filter: "url(#Rectangle_89)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89-2",
    "data-name": "Rectangle 89",
    width: 46,
    height: 27,
    rx: 10,
    transform: "translate(119 5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-gift",
    "data-name": "Icon feather-gift",
    transform: "translate(338 239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M17.689,18v7.306H6V18",
    transform: "translate(-1.539 -7.694)",
    fill: "none",
    stroke: "#dd5656",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M3,10.5H17.611v3.653H3Z",
    transform: "translate(0 -3.847)",
    fill: "none",
    stroke: "#dd5656",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M18,21.458V10.5",
    transform: "translate(-7.694 -3.847)",
    fill: "none",
    stroke: "#dd5656",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M12.614,6.653H9.326A1.826,1.826,0,1,1,9.326,3C11.883,3,12.614,6.653,12.614,6.653Z",
    transform: "translate(-2.308)",
    fill: "none",
    stroke: "#dd5656",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M18,6.653h3.287a1.826,1.826,0,1,0,0-3.653C18.731,3,18,6.653,18,6.653Z",
    transform: "translate(-7.694)",
    fill: "none",
    stroke: "#dd5656",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(-206 -231)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 60,
    height: 17,
    rx: 8.5,
    transform: "translate(251 242)",
    fill: "#33aa96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 36,
    height: 17,
    rx: 8.5,
    transform: "translate(251 242)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_15_",
    "data-name": "15\\u20AC ",
    transform: "translate(268 254)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700,
    opacity: 0.684
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.73,
    y: 0
  }, "15\u20AC ")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideButton);
export default __webpack_public_path__ + "static/media/Side-button.fb46f3d727ac55638454c498d1784b49.svg";
export { ForwardRef as ReactComponent };